import { FontWeight, HeaderMenu, StyledComponent } from '@on-arte/ui';
import styled from 'styled-components';

import { StyledHeaderMenuProps } from './headerMenu.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const StyledHeaderMenu: StyledComponent<typeof HeaderMenu, StyledHeaderMenuProps> = styled(HeaderMenu)<StyledHeaderMenuProps>`
  transition: ${({ $transitionEnabled }: StyledHeaderMenuProps): string => $transitionEnabled ? '0.3s' : 'none'};
  ${({ $top }: StyledHeaderMenuProps): string => $top !== null ? `
    position: fixed;
    top: ${$top}px;
    left: 0;
  ` : `
    position: block;
  `};
`;

/**
 * Podpis pod logo, na stronie głównej pełniący rolę `h1`. Kolor dziedziczy po nagłówku,
 * bo ten zmienia motyw przy przewijaniu (biały nad ciemnym tłem, czarny po przewinięciu).
 * Rozmiar dobrany tak, żeby podpis czytał się jako dopisek do znaku firmowego, a nie
 * jako drugi tytuł obok niego.
 */
export const LogoCaption: StyledComponent<'h1'> = styled.h1`
  margin: 0;
  font-size: 11px;
  line-height: 14px;
  font-weight: ${FontWeight.Regular};
  letter-spacing: 0.02em;
  color: inherit;
  white-space: nowrap;
`;
